import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DocumentoNoTributarioDetService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rut_empresa: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento_no_tributario_det {
              obtenerSegunFiltro(
                filtro: { exacto: { rut_empresa: $rut_empresa, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    cantidad
                    cantidad_atendida
                    descuento
                    linea
                    precio_neto
                    precio_unitario
                    monto_iva
                    monto_total
                    descuento
                    nombreFormato
                    nombreProducto
                    skuProducto
                    estadoAtendido
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_no_tributario_det.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerFiltroNotaVenta(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $filtro: FiltroInputTypeOfdocumento_no_tributarioTOdocumento_no_tributarioInputType
            $estado: [Decimal]
            $vendedor: [Decimal]
            $comuna: [Decimal]
            $clientes: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            documento_no_tributario {
              obtenerFiltroNotaVenta(filtro: $filtro, estado: $estado, vendedor: $vendedor, comuna: $comuna, clientes: $clientes, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    vendedor_nombre
                    folio
                    fecha_emision
                    direccion_cliente_rut
                    nombrecliente
                    vendedor_nombre
                    comuna
                    total_neto
                    total_bruto
                    estado_documento_codigo
                    estado_documento_nombre
                    origen
                    folio_referencia
                    direccion_codigo
                    folio_factura
                    observacion_2
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerFiltroNotaVenta;
            callback({ mensajes, respuesta });
        });
    }
}
DocumentoNoTributarioDetService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentoNoTributarioDetService_Factory() { return new DocumentoNoTributarioDetService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DocumentoNoTributarioDetService, providedIn: "root" });
